import _plugin_vue_export_helper_default from "../_virtual/_plugin-vue_export-helper.js";
import SectionFilter_vue_vue_type_script_setup_true_lang_default from "./SectionFilter.vue.script.js";
/* empty css                            */
//#region src/components/SectionFilter.vue
var SectionFilter_default = /*#__PURE__*/ _plugin_vue_export_helper_default(SectionFilter_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-48147b15"]]);
//#endregion
export { SectionFilter_default as default };

//# sourceMappingURL=SectionFilter.vue.js.map